export const headerLinks = [
	{ link: "/pieces", name: "Pieces" },
	{ link: "/outfits", name: "Outfits" },
	{ link: "/lookbooks", name: "Lookbooks" },
	{ link: "/analytics", name: "Analytics" },
	{ link: "/pieces/add_wears", name: "Add Wears" },
	{ link: "/account", name: "Account" },
];
